import React, { useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import LeftArray from 'assets/images/prev-btn.png'
import RightArray from 'assets/images/next-btn.png'
import { ProductsList } from 'service/apis/products.apis'
import { history } from 'redux/store/store'
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from 'react-icons/md'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'
import { formatCurrency } from 'utils/Currency'
import nextArrow from '../../../assets/svg/rightArrow.svg'
import prevArrow from '../../../assets/svg/leftArrow.svg'
import Currency from 'component/Currency/page'

SwiperCore.use([Navigation, Pagination, Autoplay])


const productSlug = window.location.pathname.split('/').pop()
console.log(productSlug,'productSlug');

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <>
      <div onClick={onClick} className='mt-4 d-md-none d-block'>
        <div
          className='d-flex justify-content-start align-items-center'
          style={{ position: 'absolute', top: '100%', right: '0px' }}
        >
          <span style={{ zIndex: 2 }}>Next</span>
          <div
            className='mr-2'
            style={{
              zIndex: 2,
              width: '35px',
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              boxShadow: '0px 2px 9px rgba(0, 0, 0, 0.25)',
            }}
          >
            <MdOutlineArrowForwardIos />
          </div>
        </div>
      </div>
      <div
        className={className + ' d-md-block d-none'}
        style={{
          ...style,
          backgroundImage: `url(${RightArray})`,
          backgroundRepeat: 'no-repeat',
          display: 'block',
          content: 'none',
          top: 'auto',
          bottom: '-10%',
          width: '60px',
        }}
        onClick={onClick}
      />
    </>
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <>
      <div onClick={onClick} className={' mt-4 d-md-none d-block'}>
        <div
          className='d-flex justify-content-start align-items-center'
          style={{ position: 'absolute', top: '100%' }}
        >
          <div
            className='mr-2'
            style={{
              zIndex: 2,
              width: '35px',
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              boxShadow: '0px 2px 9px rgba(0, 0, 0, 0.25)',
            }}
          >
            <MdOutlineArrowBackIos />
          </div>
          <span style={{ zIndex: 2 }}>Prev</span>
        </div>
      </div>
      <div
        className={className + ' d-md-block d-none'}
        style={{
          ...style,
          backgroundImage: `url(${LeftArray})`,
          backgroundRepeat: 'no-repeat',
          display: 'block',
          content: 'none',
          top: 'auto',
          bottom: '-10%',
          left: 'auto',
          right: '5%',
          zIndex: 1,
          width: '60px',
        }}
        onClick={onClick}
      />
    </>
  )
}

export function MultipleTabs(props) {
  const [defaulttab, setDefaultTab] = useState('UPDATED_AT')
  const [tabData, setTabData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchProducts()
  }, [defaulttab])

  const fetchProducts = async () => {
    setLoading(true)
    try {
      const response = await ProductsList({ sortKey: defaulttab })
      setTabData(response)
      console.log(response,'respomse');
      setLoading(false)
    } catch (err) { }
  }

  const handleTab = (key) => {
    if (key === 'CREATED_AT') {
      setDefaultTab('CREATED_AT')
    } else if (key === 'UPDATED_AT') {
      setDefaultTab('UPDATED_AT')
    } else if (key === 'BEST_SELLING') {
      setDefaultTab('BEST_SELLING')
    }
  }

  const swiperOptions = {
    initialSlide: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: 'row',
      },
      400: {
        slidesPerColumn: 2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        slidesPerColumnFill: 'row',
        slidesPerView: 2,
      },
      600: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  }

  return (
    <>
      <div id='multipleTabs' className=' pb-3 '>
        {props.heading ? (
          <h4 className='text-center py-3 main--title'>Shop by Products</h4>
        ) : (
          ''
        )}
        {props?.tabsData?.length ? (
          <Tabs
            defaultActiveKey={props.defaultActiveKey}
            className='nav border-top border-bottom my-sm-4 my-2 mx-2 text-grey-ee tab-pdng'
          >
            {props.tabsData.map((obj, index) => (
              <Tab
                key={index + 1}
                eventKey={obj.tabName.split(' ').join('').toLowerCase()}
                title={obj.tabName}
                className='py-sm-4 py-2'
              >
                {!loading && (
                  <div className='categorySwiper homeSwipers'>
                    <Swiper {...swiperOptions} className='slideWrapperHome'>
                      {tabData?.map((x, index) => {
                        const price = Number(x?.node?.priceRange?.minVariantPrice?.amount);

                        if (x.node.handle === productSlug || price === 0) {
                          return null; // Skip rendering this product
                        }

                        // if (price === 0) {
                        //   return null;
                        // }

                        return (
                          <SwiperSlide key={index}>
                            <div
                              className="product--a mx-2"
                              onClick={() => history.push(`/product/${x.node.handle}`)}
                            >
                              <div className="product--container">
                                <div className="">
                                  {x.node.id === 'gid://shopify/Product/7713922973862' ? (
                                    <span className='badge new-badge'>New</span>
                                  ) : (
                                    <></>
                                  )}

                                  {x.node.images?.nodes.map((image, index) => (
                                    <img
                                      className={`img-fluid heree img${index}`}
                                      src={image.url}
                                      key={index}
                                      alt=''
                                    />
                                  ))}

                                  <span className="price">
                                    <Currency />
                                    {formatCurrency(price)}
                                  </span>
                                </div>
                              </div>
                              <h1 className="product-title">{x?.node?.title}</h1>
                            </div>
                          </SwiperSlide>
                        )
                      })}

                      <div className="swiper-button-next">
                        <img src={nextArrow} alt="Arrow Right" />
                      </div>
                      <div className="swiper-button-prev">
                        <img src={prevArrow} alt="Arrow Left" />
                      </div>
                    </Swiper>
                  </div>
                )}
              </Tab>
            ))}
          </Tabs>
        ) : (
          <Tabs
            defaultActiveKey={defaulttab}
            className='nav border-top border-bottom my-sm-4 my-2 mx-2 text-grey-ee'
            onSelect={handleTab}
          >
            <Tab
              eventKey='UPDATED_AT'
              title='Best Sellers'
              className='py-sm-4 py-2'
            >
              {!loading && (
                <div className='categorySwiper'>
                  <div>
                    <div id='catPrev' className='catePrevBtn d-md-none d-block'>
                      <img alt='' src={LeftArray} className=' mr-2' />
                      Prev
                    </div>
                  </div>
                  <Swiper {...swiperOptions} className='slideWrapperHome'>
                    {tabData?.map((x, index) => {
                      const price = Number(x?.node?.priceRange?.minVariantPrice?.amount);

                      if (price === 0) {
                        return null; // Skip rendering this product
                      }

                      return (
                        <SwiperSlide key={index}>
                          <div
                            className='sliderCard cursor-pointer d-flex flex-column justify-content-center cursor-pointer bg-grey-f5 mx-2'
                            onClick={() => history.push(`/product/${x.node.handle}`)}
                          >
                            <div className='position-relative'>
                              {x?.node?.id === 'gid://shopify/Product/7699029491878' ? (
                                <span className='badge new-badge'>New</span>
                              ) : (
                                <></>
                              )}
                              <img
                                src={x?.node?.images?.nodes[0]?.url}
                                className='mx-auto p-2'
                                alt='images'
                                style={{
                                  width: '100%',
                                  height: '125px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div>
                              <span className=' bg-white p-2 mt-2'>
                                ₹ {x?.node?.priceRange?.minVariantPrice?.amount}
                              </span>
                            </div>
                            <div>
                              <span className='m-2 d-block'>
                                <p className='my-0'>{x?.node?.title}</p>
                                <p>{props?.category}</p>
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                  <div>
                    <div id='catNext' className='cateNextBtn d-md-none d-block'>
                      Next <img alt='' src={RightArray} className=' ml-2' />
                    </div>
                  </div>
                </div>
              )}
            </Tab>

            <Tab
              eventKey='BEST_SELLING'
              title='What’s Trending'
              className='py-sm-4 py-2'
            >
              {!loading && (
                <div className='categorySwiper'>
                  <div>
                    <div id='catPrev' className='catePrevBtn d-md-none d-block'>
                      <img src={LeftArray} className=' mr-2' alt='' />
                      Prev
                    </div>
                  </div>
                  <Swiper {...swiperOptions} className='slideWrapperHome'>
                    {tabData?.map((x, index) => {
                      const price = Number(x?.node?.priceRange?.minVariantPrice?.amount);

                      if (price === 0) {
                        return null; // Skip rendering this product
                      }

                      return (
                        <SwiperSlide key={index}>
                          <div
                            className='sliderCard cursor-pointer d-flex flex-column justify-content-center cursor-pointer bg-grey-f5 mx-2'
                            onClick={() => history.push(`/product/${x?.node?.handle}`)}
                          >
                            <div className='position-relative'>
                              {x?.node?.id === 'gid://shopify/Product/7699052036262' ||
                                x?.node?.id === 'gid://shopify/Product/7699058000038' ||
                                x?.node?.id === 'gid://shopify/Product/7699050332326' ||
                                x?.node?.id === 'gid://shopify/Product/7699044958374' ||
                                x?.node?.id === 'gid://shopify/Product/7699042205862' ||
                                x?.node?.id === 'gid://shopify/Product/7699029491878' ? (
                                <span className='badge new-badge'>New</span>
                              ) : (
                                <></>
                              )}
                              <img
                                src={x?.node?.images?.nodes[0]?.url}
                                className='mx-auto p-2'
                                alt='images'
                                style={{
                                  width: '100%',
                                  height: '125px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div>
                              <span className=' bg-white p-2 mt-2'>
                                ₹ {x?.node?.priceRange?.minVariantPrice?.amount}
                              </span>
                            </div>
                            <div>
                              <span className='m-2 d-block'>
                                <p className='my-0'>{x?.node?.title}</p>
                                <p>{props?.category}</p>
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                  <div>
                    <div id='catNext' className='cateNextBtn d-md-none d-block'>
                      Next <img src={RightArray} className=' ml-2' alt='' />
                    </div>
                  </div>
                </div>
              )}
            </Tab>

            <Tab
              eventKey='CREATED_AT'
              title='New Arrivals'
              className='py-sm-4 py-2'
            >
              {!loading && (
                <div className='categorySwiper'>
                  <div>
                    <div id='catPrev' className='catePrevBtn d-md-none d-block'>
                      <img src={LeftArray} className=' mr-2' alt='' />
                      Prev
                    </div>
                  </div>
                  <Swiper {...swiperOptions} className='slideWrapperHome'>
                    {tabData?.map((x, index) => {
                      const price = Number(x?.node?.priceRange?.minVariantPrice?.amount);

                      if (price === 0) {
                        return null; // Skip rendering this product
                      }

                      return (
                        <SwiperSlide key={index}>
                          <div
                            className='sliderCard cursor-pointer d-flex flex-column justify-content-center cursor-pointer bg-grey-f5 mx-2'
                            onClick={() => history.push(`/product/${x?.node?.handle}`)}
                          >
                            <div className='position-relative'>
                              {x?.node?.id ===
                                'gid://shopify/Product/7699052036262' ||
                                x?.node?.id ===
                                'gid://shopify/Product/7699058000038' ||
                                x?.node?.id ===
                                'gid://shopify/Product/7699050332326' ||
                                x?.node?.id ===
                                'gid://shopify/Product/7699044958374' ||
                                x?.node?.id ===
                                'gid://shopify/Product/7699042205862' ||
                                x?.node?.id ===
                                'gid://shopify/Product/7901555327142' ||
                                x?.node?.id ===
                                'gid://shopify/Product/7699029491878' ? (
                                <span className='badge new-badge'>New</span>
                              ) : (
                                <></>
                              )}
                              <img
                                src={x?.node?.images?.nodes[0]?.url}
                                className='mx-auto p-2'
                                alt='images'
                                style={{
                                  width: '100%',
                                  height: '125px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div>
                              <span className=' bg-white p-2 mt-2'>
                                ₹ {x?.node?.priceRange?.minVariantPrice?.amount}
                              </span>
                            </div>
                            <div>
                              <span className='m-2 d-block'>
                                <p className='my-0'>{x?.node?.title}</p>
                                <p>{props?.category}</p>
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                  <div>
                    <div id='catNext' className='cateNextBtn d-md-none d-block'>
                      Next <img src={RightArray} className=' ml-2' alt='' />
                    </div>
                  </div>
                </div>
              )}
            </Tab>
          </Tabs>
        )}
      </div>
    </>
  )
}
